import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-upload-req-add-edit-end-client-modal',
  templateUrl: './upload-req-add-edit-end-client-modal.component.html'
})
export class UploadReqAddEditEndClientModalComponent implements OnInit {

  modalData: any = {};
  type: any;
  addEditClientName: any;
  isEndClientNameValid: any;
  endClientDetails: any;

  constructor(private bsModalRef: BsModalRef, private bsModalService: BsModalService) {
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.type = this.modalData.type;
    this.addEditClientName = this.modalData.addEditClientName;
    this.isEndClientNameValid = this.modalData.isEndClientNameValid;
    this.endClientDetails = this.modalData.endClientDetails;
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  saveCallback(type, addEditClientName) {
    if (addEditClientName.length > 0) {
      this.isEndClientNameValid = false;
      if (this.modalData.saveCallback) {
        this.modalData.saveCallback(type, addEditClientName, () => {
          this.closeModal();
        });
      }
    } else {
      this.isEndClientNameValid = true;
    }
  }
}
